import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { inject, observer } from 'mobx-react'

import { Row } from '../../components/shared'

const ProDashboard = () => {

  return (
    <>
      <Row>
        <Typography variant={'h4'}>Welcome to your dashboard</Typography>
        <Box height={45} />
      </Row>
    </>
  )
}

export default inject('store')(observer(ProDashboard))
